import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../../prototypes/generic.view.ts';

import Handlebars from 'handlebars';
import HandlebarsHelpers from 'handlebarsHelpers';

import i18n from "l10n";

export default GenericView.extend({
    el: "#main",
    tagName: '',
    template: '',
    initialize: function (options) {
        var self = this;

        this.provider = options ? options.provider : null;
        const code = window.location.hash.split("=")[1];

        $.ajaxDefaultQ({
            url: window.ip+`/rest/oauthClient/${this.provider}?code=${code}`,
            type: 'GET',
        }).done(function(response, status, xhr){

            if(status == "success") {
                window.open('store.html','_self');
            }
            else {
                window.open('login.html','_self');
            }

        }).fail(function(error) {
            console.error("Login failed!")
        });
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var self = this;

        this.$el.html( this.template() );

        return this;
    },
    events:{

    },
});
